/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./label-dialog.vue?vue&type=template&id=331625ac&scoped=true&"
import script from "./label-dialog.vue?vue&type=script&lang=ts&"
export * from "./label-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331625ac",
  null
  
)

export default component.exports